export default "__VITE_ASSET__6f8bab69__"